import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { User } from '../../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  public user: User = {
    id: '',
    token: '',
    username: '',
    fullname: '',
    avatar: '',
    menu: [],
    adminMenu: {},
    isAdmin: false,
    isApi: false,
  };
  static user: any;

  // Store allowed table IDs for access control
  public allowedTableIds: Set<number> = new Set<number>();


  private readonly menuReadySubject = new ReplaySubject<void>(1);
  public readonly menuReady$ = this.menuReadySubject.asObservable();

  constructor() {}

  markMenuReady(): void {
    this.menuReadySubject.next();
  }

  /**
   * Check if user has access to a specific table
   */
  hasTableAccess(tableId: number): boolean {
    return this.allowedTableIds.has(tableId);
  }
}
